<template>
  <div class="basicStyle"> 
    <div class="querySearch">
      <div class="searchItem">
        <span>用户ID：</span>
        <el-input class="w300" v-model="queryInfo.uid" clearable size="small" placeholder=请输入用户ID></el-input>
      </div>
      <div class="searchItem">
        <span>手机号：</span>
        <el-input class="w300" v-model="queryInfo.mobile" clearable size="small" placeholder=请输入手机号></el-input>
      </div>
      <div class="searchItem">
        <span>身份</span> 
        <el-select
          v-model="queryInfo.standing"
          placeholder="请选择"
          filterable
        > 
          <el-option
            v-for="item in standingOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />  
        </el-select> 
      </div>
      <div class="searchItem">
        <span>单招年份</span> 
        <el-select
          v-model="queryInfo.year"
          placeholder="请选择"
          filterable
          clearable
        > 
          <el-option
            v-for="item in yearOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />  
        </el-select> 
      </div>
      <!-- <div class="searchItem">
        <span>省份-单招类别：</span> 
        <el-cascader
          ref="cascader"
          v-model="targetKeys"
          :options="edusList"
          :props="props"
          collapse-tags
          clearable
          style="width:250px"
          @change="handleChange"
        />
      </div> -->
 
      <div class="searchItem">
        <span>考生类别</span> 
        <el-select
          v-model="queryInfo.student_type"
          placeholder="请选择"
          filterable
          clearable
        >  
          <el-option
            v-for="item in studentTypeOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select> 
      </div>


       
      <div class="searchItem">
        <span>时间</span>
        <el-date-picker
          v-model="timeFrame"
          size="small"
          type="datetimerange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          @change="selectData"
          clearable
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <!-- <div class="searchItem"> 
        <el-checkbox
            v-model="filterChecked"
            @change="filterChange"
          >筛选字段不为空</el-checkbox>
          <el-select
            v-if="filterChecked"
            v-model="filter"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in filterOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select> 
      </div>  -->
      <div class="searchItem"> 
        <MyButton
          value="搜索"
          size="medium"
          icon="el-icon-search"
          type="1"
          @click="queryTable('search')"
        ></MyButton>
        <MyButton
          value="重置"
          size="medium"
          type="2"
          @click="resetQuery"
        ></MyButton>
        <MyButton
          v-if="excelShow == 1"
          value="导出"
          size="medium"
          type="1"
          @click="downloadExcel"
        ></MyButton>
      </div>
    </div> 
    <div class="table">
      <el-table :data="tableList" stripe style="width: 100%" border>
        <el-table-column
          prop="id"
          label="记录ID"
          align="center"
        />
        <el-table-column
          prop="uid"
          label="用户ID"
          align="center"
        />
        <el-table-column
          prop="mobile"
          label="手机号"
          align="center"
        />
        <el-table-column
          prop="standing_name"
          label="身份"
          align="center"
        />
        <el-table-column
          prop="year"
          label="单招年份"
          align="center"
        />
        <el-table-column
          prop="province_name"
          label="报考省份"
          align="center"
        /> 
        <el-table-column
          prop="senioriup_enroll_type_name"
          label="考生类别"
          align="center"
        />
        <el-table-column
          prop="school_name"
          label="就读学校"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="首次填写时间"
          align="center"
        />
        <el-table-column
          prop="updated_at"
          label="更新时间"
          align="center"
        />  
        <!-- <el-table-column
          prop="avatar"
          label="操作"
          align="center"
          width="220"
        >
          <template slot-scope="scope">  
            <el-button type="text" size="mini" @click="savePic(scope.row)"
              >保存图片</el-button
            >
          </template>
        </el-table-column> -->
      </el-table> 
    </div>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page"
        :page-sizes="[10, 30, 50, 80]"
        :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="queryInfo.total"
      >
      </el-pagination>
    </div>  

    
    <el-dialog
      title=""
      :visible.sync="excelVisible"
      class="formDialog"
      width="600px"
    >
      <div style="text-align: center; padding: 20px 0">
        导出任务已提交，请前往
        <span style="color: #409eff; cursor: pointer" @click="excelClick"
          >数据导出中心</span
        >
        查看进度
      </div>
    </el-dialog>
  </div>
</template>

<script>   
import Api from "@/api/student"; 
import qee from "qf-export-excel";
import { deepClone } from '@/utils'
import MyButton from "@/components/MyButton.vue";
export default {
  name: "SenioriupUserList",
  components: { 
    MyButton,
  },
  data() {
    return {
      queryInfo: {
        year: 0,
        standing: 0,
        limit: 10,
        page: 1,
        total: 0, 
        student_type: 0,
      }, 
      tableList: [],   
      standingOptions: [ //身份：0不限 1考生 2家长 3其他
        // {value: 0, label: '不限'},
        // {value: 1, label: '考生'},
        // {value: 2, label: '家长'},
        // {value: 3, label: '其他'},
      ],
      yearOptions: [
        // {
        //   value: '2025',
        //   label: '2025'
        // },
        // {
        //   value: '2026',
        //   label: '2026'
        // },
        // {
        //   value: '2027',
        //   label: '2027'
        // },
        // {
        //   value: '2028',
        //   label: '2028'
        // },
        // {
        //   value: '2029',
        //   label: '2029'
        // }
      ], 
      targetKeys: [],
      edusList: [],
      props: { multiple: true }, 
      timeFrame:[],
      // filterChecked: false,
      filter: '1',
      // filterOptions: [
      //   // 0不限1考试成绩2志愿优先级3志愿意向4院校意向
      //   {
      //     value: '1',
      //     label: '考试成绩'
      //   },
      //   {
      //     value: '2',
      //     label: '志愿优先级'
      //   },
      //   {
      //     value: '3',
      //     label: '专业意向'
      //   },
      //   {
      //     value: '4',
      //     label: '院校意向'
      //   }
      // ],
      excelVisible: false,
      excelShow: 0,
      studentTypeOptions: []
    };
  },
  created() { 
    this.show_student_archive = localStorage.getItem("show_student_archive");
    console.log("this.show_student_archive", this.show_student_archive); 
    console.log("excelShow", localStorage.getItem('excelShow')); 
    this.excelShow = localStorage.getItem('excelShow') 
    // this.getQuestionEdus(); 
    this.queryTable(); 
  },
  computed: {},
  watch: {
    timeFrame:{
      handler(_newVal){
        if(!_newVal){
          this.timeFrame = [];
        }
      },
      deep:true
    }, 
  },
  methods: {
    excelClick() {
      // 数据导出中心
      this.$router.push({
        path: "/cardExportLog",
      });
    },
    // 生成随机数
    generate() {
      let timeStr = new Date().valueOf() + "";
      let randomStr = Math.random() + "";
      return timeStr.slice(2, 8) + randomStr.slice(2, 8);
    },
    getCurrentDate() {
      let now = new Date();
      let year = ("000" + now.getFullYear()).slice(-4);
      let month = ("0" + (now.getMonth() + 1)).slice(-2);
      let day = ("0" + now.getDate()).slice(-2);
      return year.toString() + month.toString() + day.toString();
    },
    downloadExcel() {
      this.$confirm("是否确定导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var query = deepClone(this.queryInfo)
          query.limit = 10000;
          Api
            .getSenioriupUserList(query)
            .then((res) => {
              if (res.code === 200) {
                console.log("studentsImportListDetail", res.data);
                this.excelVisible = true;
                this.$message({
                  type: "success",
                  message: res.message,
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });


      // this.$confirm("是否确定导出数据？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => { 
      //     var query = deepClone(this.queryInfo)
      //     if (this.filterChecked) {
      //       query.filter = this.filter
      //     } else {
      //       query.filter = '0'
      //     }   
      //     query.limit = 1000;
      //     var titleList = [
      //       { title: "记录ID", key: "id" },
      //       { title: "用户ID", key: "uid" },
      //       { title: "手机号", key: "mobile" },
      //       { title: "身份", key: "standing_name" },
      //       { title: "单招年份", key: "year" },
      //       { title: "报考省份", key: "province_name" },
      //       { title: "单招类别", key: "single_move_category_name" },
      //       { title: "就读学校", key: "school_name" },
      //       { title: "首次填写时间", key: "created_at" },
      //       { title: "更新时间", key: "updated_at" }, 
      //     ]; 
      //     Api
      //     .getSenioriupUserList(query).then((res) => {
      //       if (res.code === 200) { 
      //         console.log("excelTabelList", res.data)
      //         this.excelTabelList = res.data.list; 
      //         const randomStr = this.getCurrentDate() + this.generate();
      //         const fileName = randomStr;
      //         qee(titleList, this.excelTabelList, fileName);
      //       } else {
      //         this.$message.error(res.message);
      //       } 
      //     })
      //     .catch(() => {
      //       this.$message({
      //         type: "info",
      //         message: "已取消",
      //       });
      //     });
      //   });  
    }, 
    // filterChange(e) {
    //   console.log('filterChange', e)
    //   if (e) {
    //     this.filter = '1'
    //   }
    // }, 
    handleChange(e) {
      console.log('handleChange', e)
    },
    // 列表数据
    async queryTable() {
      var query = deepClone(this.queryInfo)
      // if (this.filterChecked) {
      //   query.filter = this.filter
      // } else {
      //   query.filter = '0'
      // }
      const res = await Api.getSenioriupUserList(query);
      if (res.code == 200) {
        this.queryInfo.total = res.data.total;
        this.tableList = res.data.list; 

        this.standingOptions = res.data.standing_list; 
        this.yearOptions = res.data.year_list;  

        
        this.studentTypeOptions = res.data.student_type_list

        this.$forceUpdate()
      } else {
        this.$message.error(res.message);
      }
    },
    selectData(e){
      //  e);
      if(e){
        this.queryInfo.start_time = e[0]
        this.queryInfo.end_time = e[1]
      }else{
        this.queryInfo.start_time = ''
        this.queryInfo.end_time = ''
      }
      //  this.queryInfo);
    },
    // 分页
    handleSizeChange(e) { 
      this.queryInfo.limit = e;
      this.queryTable();
    },
    handleCurrentChange(e) {
      this.queryInfo.page = e;
      this.queryTable();
    }, 
    // 重置
    resetQuery() {
      // this.filterChecked = false
      // this.filter = '1'
      this.timeFrame = [];
      this.queryInfo = {
        start_time:"",//创建开始时间
        end_time:"",//创建结束时间
        year: 0,
        standing: 0,
        limit: 10,
        page: 1,
        total: 0
      };
      this.queryTable();
    },
  },
};
</script>

<style lang="less" scoped>
.basicStyle {
  span {
    display: inline-block;
  }
  .querySearch {
    .searchItem {
      display: inline-block;
      margin: 0 20px 10px 0;
      span {
        margin-right: 10px;
        font-size: 14px;
        padding: 5px 0;
      }
      /deep/ .el-input {
        width: 230px;
        padding: 5px 0;
      }
    }
    /deep/ .el-button--primary {
      // margin-left: 50px;
    }
  }
  .addInfo {
    margin: 20px 0;
  }

  // 表格数据
  .table {
    min-height: calc(100vh - 330px);
    .studentLabel {
      display: inline-block;
      padding: 5px 10px;
      background-color: #409eff;
      color: #fff;
      border-radius: 4px;
      margin: 0 5px 5px 0;
    }
  }
  .operationItem {
    // display: inline-block;
    // margin: 0 5px;
    // cursor: pointer;
    // color: rgb(87, 87, 239);
  }
  .el-button.is-plain:hover {
    // border: none;
  }

  /deep/ .formDialog {
    .el-select .el-input {
      width: 180px;
    }
    .el-input {
      width: 250px;
    }
    .dialog-footer {
      text-align: center;
    }
  }
}

// 添加标签样式
/deep/ .editLabelClass {
  display: flex;
  align-items: flex-start;
  .p1 {
    margin-right: 20px;
    width: 70px;
    line-height: 30px;
  }
  .p2 {
    flex: 1;
  }
  .el-tag {
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .searchItem {
    .el-input {
      width: 200px;
      margin: 0 20px;
    }
  }
}
.editLabelClass + .editLabelClass {
  margin-top: 20px;
}
.tooltip-width {
  max-width: 200px;
}

/deep/ .recommendBox {
  display: block;
  margin-top: 20px;
  .recommend {
    margin-top: 20px;
    display: flex;
    .recommendItem {
      margin: 0 5px;
      padding: 15px;
      text-align: center;
      border: 1px solid #ddd;
      width: 360px;
      .itemTop {
        display: flex;
        justify-content: space-between;

        .itemTopL {
          width: 20%;
          // height: 40px;
          // background-color: #ddd;
          .img {
            width: 100%;
            // height: 40px;
          }
        }
        .itemTopR {
          width: 75%;
          .title {
            font-size: 15px;
            color: #333;
            font-weight: bold;
            text-align: left;
            line-height: 120%;
          }
          .cont {
            font-size: 14px;
            color: #434446;
            text-align: left;
            margin-top: 5px;
            .contItem {
              margin-right: 10px;
            }
          }
        }
      }
      .itemBt {
        justify-content: flex-end;
        display: flex;
        margin-top: 10px;
      }
    }
  }
}

.top-h1 {
  display: block;
  position: relative;
  .text {
    position: absolute;
    left: 0;
    top: 16px;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    margin-left: 25px;
  }
  .img {
    display: block;
    width: 100%;
  }
  .logo {
    display: block;
    width: 120px;
    height: 54px;
    position: absolute;
    right: 0;
    top: 13px;
    padding: 5px 3px 5px 12px;
    background-color: #fff;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }
}

.top-h2 {
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  box-shadow: 0px -4px 20px 0px rgba(172, 159, 255, 0.3);
  margin-top: -20px;
  background-color: #fff;
  z-index: 1;
  position: relative;
  .top-h2-box {
    padding: 25px 25px 0 25px;
    .img {
      width: 135px;
      display: block;
      margin: 0 auto;
      padding-bottom: 20px;
    }
    .int1Box {
      padding-bottom: 20px;
      input,
      .input {
        width: calc(100% - 48px);
        height: 46px;
        padding: 0 24px 0 24px;
        background: #f7f8fb;
        border-radius: 280px;
        border: none;
        opacity: 1;
      }
    }
    .int2Box {
      position: relative;
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      border-radius: 4px;
      overflow: hidden;
      background: #f7f8fb;
      padding: 0 24px;
      height: 46px;
      border-radius: 280px;
      margin-bottom: 22px;
      input,
      .input {
        position: relative;
        width: 60%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 9px;
        font-size: 13px;
        line-height: 100%;
        background: #f7f8fb;
        border: none;
        &.invalid,
        &::-webkit-input-placeholder {
          color: #999fb5;
        }
        &.alignRight {
          text-align: right;
        }
        .arrows {
          position: absolute;
          top: 0;
          right: 10px;
        }
      }
      .shape,
      .btn,
      .mask {
        position: absolute;
        top: 0;
        right: 0;
        height: 100%;
        line-height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .shape {
        right: 10px;
        color: #999fb5;
      }
      .btn {
        right: 24px;
        width: 100px;
        font-size: 13px;
        font-family: "PingFang SC-常规体", "PingFang SC";
        color: #5659dd;
        &.invalid {
          color: #999fb5;
          width: auto;
          padding: 0 10px;
        }
      }
      .mask {
        width: 100%;
        opacity: 0;
        z-index: 9;
      }
      & + .inp {
        margin-left: 10px;
      }
    }
    .int3Box {
      display: block;
      .img {
        display: block;
        width: 100%;
      }
    }
  }
}

.top-h3 {
  display: block;
  .img {
    display: block;
    width: 100%;
  }
}
.top-h4 {
  padding-top: 28px;
  background: url(../../assets/img/tobpic13.png) no-repeat;
  background-size: 100% auto;
  .title {
    display: block;
    margin: 0 auto;
    width: 150px;
  }
  .cont {
    padding: 32px 29px 42px 29px;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #465069;
    line-height: 28px;
    // min-height: 200px;
  }
}

.top-h5 {
  padding-top: 28px;
  padding-bottom: 36px;
  padding-left: 26px;
  padding-right: 26px;
  padding-top: 26px;
  background: url(../../assets/img/tobpic15.png) no-repeat;
  background-size: 100% auto;
  .title {
    display: block;
    margin: 0 auto;
    width: 150px;
    padding-bottom: 36px;
  }
  .cont {
    padding: 16px 19px;
    background-color: #fff;
    box-shadow: 0px 5px 18px 0px rgba(234, 218, 255, 0.6554);
    border-radius: 19px;
    .contItem1 {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .pic {
        display: inline-block;
        width: 17px;
        height: 17px;
        vertical-align: middle;
        margin-right: 10px;
      }
      .text {
        display: inline-block;
        font-size: 15px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #465069;
        line-height: 17px;
        width: 80%;
        vertical-align: middle;
      }
    }
    .contItem2 {
      display: flex;
      justify-content: space-between;
      .itemLeft {
        width: 70%;
        .pic {
          display: inline-block;
          width: 17px;
          vertical-align: middle;
          margin-right: 10px;
        }
        .text {
          display: inline-block;
          font-size: 15px;
          font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
          font-weight: 400;
          color: #465069;
          line-height: 15px;
          width: 60%;
          vertical-align: middle;
        }
      }

      .itemRight {
        background: #ff7f3b;
        box-shadow: 0px 0px 12px 0px rgba(91, 37, 240, 0.1);
        border-radius: 50px;
        font-size: 13px;
        font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi;
        font-weight: 400;
        color: #ffffff;
        line-height: 100%;
        padding: 5px 11px;
      }
    }
  }

  .wx-title {
    font-size: 17px;
    font-family: PingFang SC-Bold, PingFang SC;
    font-weight: 400;
    color: #ff7c39;
    line-height: 100%;
    text-align: center;
    padding: 26px 0 20px 0;
    .pic {
      display: inline-block;
      width: 8px;
      vertical-align: middle;
      margin: 0 4px;
    }
  }
  .wx-img {
    width: 163px;
    height: 163px;
    margin: 0 auto;
    .img {
      width: 100%;
      height: 100%;
    }
  }
}

.wx-submit {
  padding: 12px 16px 10px 16px;
  background-color: #fff;
  margin-top: -12px;
  .submit {
    width: 100%;
    height: 48px;
    display: block;
    text-align: center;
    line-height: 48px;
    background: linear-gradient(270deg, #ff7c39 0%, #ffb15c 100%);
    border-radius: 26px;
    font-size: 16px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 48px;
  }
}
</style>
